import { Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import LoaderComponent from './LoaderComponent';
import Router from './Router';
import { Permissions } from '../../ts-helpers/permission';

function LoadableComponent({ ViewComponent, ViewProps }) {
  return (
    <Suspense fallback={<LoaderComponent />}>
      <ViewComponent {...ViewProps} />
    </Suspense>
  );
}

const makeRouteViewWithoutLayout = (args: any, ViewComponent: any) => {
  return (
    <Route
      {...args}
      render={(props: any) => <LoadableComponent ViewComponent={ViewComponent} ViewProps={props} />}
    />
  );
};

const makeRouteViewWithLayout = (args: any, ViewComponent: any) => {
  const PageLayout = args.layout;
  return (
    <Route
      {...args}
      render={(props: any) => (
        <PageLayout>
          <LoadableComponent ViewComponent={ViewComponent} ViewProps={props} />
        </PageLayout>
      )}
    />
  );
};

const makeRouteRedirectToLogin = (args: any) => {
  const redirectData = {
    pathname: Router.toUrl('login_with_email'),
    state: {
      from: args.location,
    },
  };

  return <Redirect to={redirectData} />;
};

const RouteItem = ({ component, isLogged, loggedUser, ...args }: any) => {
  const hasPermissionRole = !args.role || (isLogged && loggedUser.role == args.role);
  const hasAccess =
    (!args.permissionName && !args.permissionNamesGroup) ||
    (isLogged && !!args.permissionNamesGroup
      ? Permissions.hasOneOf(args.permissionNamesGroup)
      : args.requiredManageAccess
      ? Permissions.manage(args.permissionName)
      : Permissions.has(args.permissionName));

  if (!hasPermissionRole || !hasAccess) {
    return <Redirect to="/" />;
  }

  if (!args.auth || (args.auth && isLogged)) {
    if (args.layout === null || args.layout === undefined) {
      return makeRouteViewWithoutLayout(args, component);
    } else {
      return makeRouteViewWithLayout(args, component);
    }
  } else {
    return makeRouteRedirectToLogin(args);
  }
};

export default connect((state: any) => {
  return {
    isLogged: state.AuthReducer.isLogged,
    loggedUser: state.AuthReducer.user,
  };
})(RouteItem);
